/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Pricing_Save_Up_ToInputs */

const en_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Save up to ${i?.percent}%`)
};

const de_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spare bis zu ${i?.percent}%`)
};

const fr_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Economisez jusqu'a ${i?.percent}%`)
};

const es_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ahorra hasta un ${i?.percent}%`)
};

const it_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Risparmia fino al ${i?.percent}%`)
};

const nl_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bespaar tot ${i?.percent}%`)
};

const pl_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oszczedz do ${i?.percent}%`)
};

const fi_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Säästä jopa ${i?.percent}%`)
};

const da_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spar op til ${i?.percent}%`)
};

const sv_pricing_save_up_to = /** @type {(inputs: Pricing_Save_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spara upp till ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Save up to {percent}%" |
*
* @param {Pricing_Save_Up_ToInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_save_up_to = /** @type {((inputs: Pricing_Save_Up_ToInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Save_Up_ToInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_save_up_to(inputs)
	if (locale === "fr") return fr_pricing_save_up_to(inputs)
	if (locale === "es") return es_pricing_save_up_to(inputs)
	if (locale === "it") return it_pricing_save_up_to(inputs)
	if (locale === "nl") return nl_pricing_save_up_to(inputs)
	if (locale === "pl") return pl_pricing_save_up_to(inputs)
	if (locale === "fi") return fi_pricing_save_up_to(inputs)
	if (locale === "da") return da_pricing_save_up_to(inputs)
	if (locale === "sv") return sv_pricing_save_up_to(inputs)
	return en_pricing_save_up_to(inputs)
});